import { Navigate } from "react-router-dom";

export const EventTypes = () => {
  return <Navigate to="/config/tipo-datos" replace />;
};
